import Link from '@mui/material/Link';

// ----------------------------------------------------------------------

// Each dot in the domain must be followed by a label, so a sentence-ending period is left out.
const EMAIL_PATTERN = /([\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g;

/**
 * Renders a plain-text message (e.g. a backend error shown in a toast) with every email
 * address turned into a mailto link. The backend sends plain text rather than Markdown,
 * since toasts don't render Markdown.
 *
 * @param {string} message
 */
export function linkifyEmails(message) {
  // split() with a capture group keeps the matches at the odd indexes.
  const parts = message.split(EMAIL_PATTERN);
  if (parts.length === 1) return message;

  return (
    <span>
      {parts.map((part, index) =>
        index % 2 === 0 ? (
          part
        ) : (
          <Link key={index} href={`mailto:${part}`} color="inherit" underline="always">
            {part}
          </Link>
        )
      )}
    </span>
  );
}
